var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1312,
    height: 316,
    viewBox: "0 0 1312 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1357.94 191.51C1357.94 191.51 1177.43 218.097 932.523 147.605C742.887 93.0258 615.071 105.754 466.609 191.327C318.129 276.892 256.347 327.713 3.98242 292.871",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.34 189.723C1357.34 189.723 1174.9 214.057 930.632 147.19C741.093 95.3041 614.978 110.884 464.352 194.337C313.726 277.798 254.728 326.101 3.07812 292.464",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.74 187.943C1356.74 187.943 1172.3 210.016 928.734 146.774C739.272 97.5733 614.897 116.005 462.087 197.354C309.295 278.704 253.1 324.488 2.14648 292.064",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.12 186.164C1356.12 186.164 1169.66 205.984 926.84 146.358C737.417 99.8514 614.801 121.126 459.845 200.372C304.888 279.61 251.477 322.875 1.25781 291.665",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.52 184.377C1355.52 184.377 1166.99 201.944 924.946 145.943C735.523 102.113 614.705 126.256 457.583 203.391C300.462 280.525 249.854 321.262 0.349609 291.267",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1354.93 182.598C1354.93 182.598 1164.27 197.911 923.074 145.527C733.631 104.382 614.63 131.377 455.343 206.4C296.057 281.423 248.251 319.641 -0.556641 290.85",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1354.32 180.811C1354.32 180.811 1161.5 193.872 921.177 145.112C731.657 106.653 614.531 136.499 453.08 209.418C291.628 282.338 246.626 318.029 -1.48633 290.452",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.73 179.032C1353.73 179.032 1158.68 189.848 919.284 144.696C729.648 108.922 614.455 141.628 450.838 212.436C287.221 283.244 245.003 316.416 -2.375 290.053",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.11 177.252C1353.11 177.252 1155.78 185.832 917.389 144.288C727.599 111.208 614.358 146.757 448.576 215.462C282.795 284.15 243.379 314.802 -3.2832 289.645",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.51 175.465C1352.51 175.465 1152.84 181.825 915.493 143.865C725.49 113.478 614.26 151.879 446.313 218.463C278.366 285.056 241.753 313.19 -4.21289 289.246",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.91 173.685C1351.91 173.685 1149.86 177.834 913.617 143.448C723.362 115.764 614.181 157 444.089 221.481C273.977 285.962 240.148 311.576 -5.10352 288.838",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.31 171.898C1351.31 171.898 1146.84 173.844 911.723 143.033C721.197 118.059 614.104 162.121 441.827 224.499C269.55 286.877 238.524 309.964 -6.01172 288.44",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.71 170.119C1350.71 170.119 1143.75 169.886 909.85 142.617C718.996 120.37 614.029 167.251 439.587 227.517C265.164 287.783 236.922 308.351 -6.91797 288.04",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1350.11 168.34C1350.11 168.34 1140.62 165.945 907.956 142.21C716.715 122.697 613.933 172.38 437.326 230.535C260.738 288.689 235.279 306.738 -7.82617 287.641",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1349.49 166.552C1349.49 166.552 1137.43 162.021 906.04 141.786C714.394 125.025 613.815 177.493 435.062 233.544C256.309 289.595 233.654 305.117 -8.75586 287.234",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.89 164.773C1348.89 164.773 1134.2 158.131 904.166 141.37C712.094 127.378 613.738 182.623 432.82 236.562C251.902 290.501 232.05 303.504 -9.64453 286.827",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.29 162.994C1348.29 162.994 1130.96 154.265 902.273 140.963C709.718 129.756 613.663 187.752 430.561 239.58C247.478 291.408 230.409 301.891 -10.5703 286.428",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.7 161.207C1347.7 161.207 1127.67 150.424 900.399 140.539C707.341 132.142 613.586 192.865 428.319 242.589C243.071 292.314 228.805 300.27 -11.459 286.02",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.1 159.427C1347.1 159.427 1124.37 146.616 898.505 140.131C704.925 134.569 613.49 198.003 426.077 245.616C238.664 293.228 227.201 298.665 -12.3672 285.629",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.48 157.64C1346.48 157.64 1121 142.833 896.589 139.707C702.487 137.006 613.372 203.116 423.794 248.625C234.216 294.135 225.536 297.044 -13.2969 285.222",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.88 155.861C1345.88 155.861 1117.68 139.084 894.716 139.3C700.054 139.483 613.297 208.245 421.554 251.651C229.811 295.049 223.934 295.44 -14.2031 284.823",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.28 154.082C1345.28 154.082 1114.31 135.376 892.82 138.885C697.617 141.978 613.218 213.376 419.291 254.662C225.382 295.947 222.309 293.827 -15.1133 284.416",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.68 152.295C1344.68 152.295 1110.99 131.685 890.944 138.461C695.18 144.496 613.139 218.488 417.066 257.671C220.993 296.853 220.703 292.206 -16.0039 284.009",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.08 150.515C1344.08 150.515 1107.64 128.027 889.05 138.053C692.764 147.057 613.043 223.626 414.805 260.697C216.566 297.768 219.079 290.601 -16.9121 283.618",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.48 148.727C1343.48 148.727 1104.34 124.393 887.175 137.628C690.367 149.625 612.966 228.738 412.563 263.698C212.159 298.673 217.456 288.979 -17.8203 283.21",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.86 146.949C1342.86 146.949 1101.03 120.802 885.261 137.222C687.951 152.236 612.85 233.868 410.282 266.724C207.713 299.58 215.832 287.367 -18.748 282.803",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.26 145.17C1342.26 145.17 1097.77 117.227 883.367 136.806C685.593 154.864 612.773 238.99 408.04 269.742C203.306 300.486 214.209 285.755 -19.6562 282.404",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.66 143.383C1341.66 143.383 1094.55 113.669 881.489 136.391C683.27 157.524 612.693 244.12 405.794 272.76C198.895 301.401 212.601 284.142 -20.5488 282.005",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.07 141.603C1341.07 141.603 1091.37 110.144 879.598 135.975C680.973 160.201 612.6 249.241 403.536 275.77C194.473 302.299 210.981 282.52 -21.4727 281.598",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.46 139.824C1340.46 139.824 1088.24 106.635 877.722 135.559C678.73 162.894 612.502 254.361 401.293 278.787C190.083 303.213 209.356 280.907 -22.3633 281.198",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.84 138.036C1339.84 138.036 1085.12 103.135 875.806 135.143C676.524 165.613 612.403 259.491 399.029 281.805C185.655 304.119 207.731 279.294 -23.293 280.791",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.25 136.257C1339.25 136.257 1082.09 99.6603 873.912 134.728C674.359 168.34 612.327 264.613 396.768 284.823C181.228 305.025 206.107 277.682 -24.2012 280.392",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.65 134.47C1338.65 134.47 1079.11 96.1851 872.04 134.312C672.274 171.083 612.252 269.742 394.528 287.833C176.823 305.932 204.486 276.06 -25.1074 279.985",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.05 132.69C1338.05 132.69 1076.17 92.7264 870.144 133.896C670.223 173.843 612.154 274.863 392.284 290.85C172.414 306.838 202.88 274.456 -25.998 279.585",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1337.45 130.912C1337.45 130.912 1073.29 89.2766 868.271 133.481C668.235 176.612 612.078 279.993 390.044 293.869C168.009 307.744 201.278 272.843 -26.9043 279.178",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.85 129.124C1336.85 129.124 1070.47 85.8184 866.375 133.065C666.281 179.389 611.98 285.115 387.78 296.887C163.581 308.651 199.633 271.222 -27.834 278.78",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.23 127.345C1336.23 127.345 1067.69 82.3675 864.461 132.649C664.386 182.165 611.903 290.235 385.519 299.904C159.154 309.564 198.009 269.617 -28.7422 278.38",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.63 125.557C1335.63 125.557 1064.96 78.909 862.585 132.233C662.529 184.942 611.805 295.365 383.275 302.913C154.745 310.462 196.403 267.996 -29.6328 277.972",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.04 123.779C1335.04 123.779 1062.28 75.4596 860.694 131.818C660.716 187.728 611.712 300.487 381.018 305.932C150.323 311.378 194.764 266.384 -30.5566 277.574",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.43 121.999C1334.43 121.999 1059.64 72.0089 858.814 131.41C658.971 190.521 611.63 305.616 378.77 308.958C145.91 312.292 193.154 264.779 -31.4512 277.175",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.83 120.212C1333.83 120.212 1057.05 68.5424 856.922 130.987C657.233 193.29 611.535 310.737 376.51 311.959C141.485 313.19 191.533 263.15 -32.377 276.759",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.24 118.432C1333.24 118.432 1054.5 65.075 855.028 130.57C655.552 196.066 611.458 315.858 374.268 314.977C137.078 314.095 189.91 261.536 -33.2656 276.359",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1138.1 183.972C1138.1 183.972 922.341 186.715 806.643 117.687C690.946 48.6578 581.788 22.8355 441.44 127.43C301.078 232.017 169.022 291.443 -46 201.505",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.8125 203.293C166.954 291.036 294.719 228.816 437.348 126.79C579.976 24.7645 687.019 54.2698 807.807 119.275C928.595 184.28 1140.16 178.551 1143.5 179.175",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.625 205.08C164.9 290.628 288.376 225.615 433.27 126.15C578.164 26.6845 683.092 59.8894 808.985 120.862C934.878 181.835 1142.21 173.122 1148.89 174.377",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.4531 206.867C162.831 290.22 282.017 222.414 429.177 125.509C576.337 28.6131 679.165 65.501 810.133 122.45C941.116 179.399 1144.25 167.701 1154.25 169.58",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.2656 208.655C160.777 289.814 275.674 219.206 425.099 124.878C574.525 30.5426 675.239 71.1301 811.312 124.047C947.385 176.964 1146.31 162.282 1159.64 164.792",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.0781 210.442C158.724 289.414 269.316 216.004 421.022 124.237C572.728 32.4707 671.312 76.7411 812.491 125.642C953.654 174.535 1148.38 156.86 1165.05 160.003",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.9082 212.23C156.637 289.007 262.955 212.804 416.927 123.598C570.898 34.3919 667.383 82.362 813.652 127.231C959.92 172.1 1150.41 151.441 1170.43 155.207",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.7227 214.018C154.582 288.6 256.61 209.603 412.847 122.966C569.084 36.3287 663.455 87.9818 814.813 128.827C966.172 169.664 1152.47 146.02 1175.8 150.418",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.5352 215.805C152.528 288.192 250.267 206.402 408.77 122.326C567.272 38.2573 659.543 93.6017 815.992 130.415C972.441 167.228 1154.54 140.599 1181.19 145.621",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.3633 217.593C150.459 287.785 243.893 203.202 404.676 121.694C565.445 40.1867 655.601 99.2223 817.155 132.012C978.709 164.801 1156.58 135.179 1186.59 140.832",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.1758 219.38C148.405 287.378 237.55 200.001 400.599 121.054C563.648 42.1067 651.69 104.834 818.334 133.599C984.977 162.356 1158.64 129.75 1191.98 136.027",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.9902 221.167C146.334 286.979 231.205 196.8 396.519 120.413C561.834 44.0355 647.761 110.454 819.495 135.187C991.229 159.92 1160.68 124.329 1197.36 131.23",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.80078 222.955C144.283 286.571 224.863 193.591 392.444 119.782C560.024 45.9645 643.852 116.074 820.676 136.783C997.5 157.493 1162.75 118.909 1202.77 126.441",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.62695 224.742C142.215 286.164 218.506 190.39 388.352 119.141C558.198 47.8929 639.912 121.694 821.841 138.371C1003.77 155.048 1164.8 113.488 1208.14 121.644",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.44141 226.529C140.16 285.756 212.146 187.189 384.273 118.501C556.399 49.8133 635.998 127.305 823.018 139.959C1010.04 152.612 1166.86 108.059 1213.53 116.847",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.74414 228.317C138.104 285.349 205.801 183.989 380.193 117.87C554.586 51.7425 632.07 132.926 824.179 141.555C1016.29 150.185 1168.9 102.647 1218.91 112.058",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91406 230.104C136.018 284.941 199.44 180.787 376.098 117.229C552.756 53.6707 628.141 138.545 825.34 143.143C1022.55 147.74 1170.95 97.2179 1224.3 107.261",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10352 231.901C133.966 284.543 193.099 177.587 372.023 116.598C550.946 55.6001 624.216 144.166 826.521 144.74C1028.83 145.313 1173.01 91.7979 1229.7 102.473",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.291 233.687C131.913 284.135 186.741 174.394 367.945 115.965C549.134 57.5367 620.305 149.794 827.7 146.335C1035.09 142.885 1175.08 86.3853 1235.09 97.6836",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4609 235.467C129.841 283.728 180.38 171.186 363.85 115.318C547.32 59.4496 616.36 155.398 828.845 147.916C1041.33 140.433 1177.1 80.9489 1240.45 92.879",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6484 237.254C127.788 283.32 174.037 167.984 359.772 114.677C545.508 61.3776 612.449 161.009 830.024 149.503C1047.61 137.997 1179.17 75.5275 1245.86 88.0812",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8379 239.05C125.721 282.921 167.695 164.783 355.697 114.053C543.698 63.3146 608.525 166.646 831.205 151.107C1053.89 135.569 1181.24 70.1153 1251.25 83.3008",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0234 240.838C123.665 282.514 161.335 161.583 351.617 113.413C541.884 65.2438 604.611 172.258 832.381 152.696C1060.15 133.134 1183.3 64.6951 1256.64 78.5042",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1953 242.625C121.596 282.106 154.976 158.382 347.524 112.773C540.071 67.1639 600.669 177.878 833.544 154.292C1066.4 130.697 1185.33 59.2742 1262.02 73.7068",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3828 244.413C119.542 281.7 148.633 155.182 343.446 112.142C538.259 69.1016 596.758 183.498 834.708 155.888C1072.67 128.27 1187.39 53.8542 1267.41 68.9187",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5703 246.2C117.474 281.301 142.29 151.981 339.369 111.502C536.447 71.0224 592.831 189.11 835.887 157.477C1078.93 125.835 1189.44 48.4257 1272.79 64.122",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7402 247.987C115.403 280.893 135.914 148.78 335.273 110.869C534.618 72.9589 588.902 194.738 837.048 159.072C1085.19 123.398 1191.5 43.0046 1278.18 59.3244",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9258 249.775C113.347 280.486 129.569 145.579 331.194 110.229C532.804 74.8793 584.973 200.35 838.209 160.66C1091.46 120.962 1193.55 37.584 1283.57 54.5357",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1133 251.562C111.293 280.078 123.226 142.378 327.116 109.589C531.007 76.808 581.047 205.97 839.388 162.248C1097.73 118.526 1195.6 32.1634 1288.96 49.7386",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2871 253.35C109.226 279.671 116.869 139.169 323.025 108.957C529.181 78.7369 577.122 211.59 840.553 163.844C1103.98 116.09 1197.66 26.743 1294.34 44.9417",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4727 255.137C107.155 279.264 110.524 135.969 318.945 108.317C527.367 80.666 573.193 217.202 841.73 165.433C1110.25 113.655 1199.71 21.3227 1299.73 40.1533",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6582 256.925C105.1 278.865 104.163 132.768 314.866 107.677C525.553 82.5863 569.28 222.822 842.906 167.02C1116.53 111.219 1201.78 15.8937 1305.14 35.3561",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.832 258.712C103.032 278.457 97.8064 129.567 310.775 107.045C523.743 84.5149 565.34 228.442 844.056 168.616C1122.77 108.783 1203.82 10.4731 1310.5 30.559",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0195 260.499C100.979 278.05 91.4632 126.366 306.697 106.405C521.931 86.4437 561.428 234.062 845.235 170.204C1129.04 106.347 1205.88 5.05255 1315.89 25.7703",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.207 262.287C98.9101 277.642 85.1049 123.166 302.604 105.765C520.104 88.3644 557.487 239.674 846.398 171.792C1135.31 103.911 1207.93 -0.36783 1321.29 20.9735",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3926 264.074C96.8545 277.235 78.7597 119.956 298.525 105.133C518.29 90.3013 553.573 245.294 847.575 173.388C1141.56 101.475 1209.98 -5.78845 1326.66 16.1764",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5645 265.862C94.7852 276.827 72.4009 116.764 294.447 104.493C516.477 92.2216 549.646 250.914 848.738 174.976C1147.83 99.0388 1212.04 -11.2092 1332.06 11.3874",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.752 267.649C92.7316 276.42 66.0577 113.555 290.369 103.853C514.681 94.1507 545.735 256.526 849.917 176.564C1154.1 96.6032 1214.09 -16.6378 1337.45 6.59072",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9395 269.437C90.678 276.013 59.7145 110.354 286.292 103.221C512.869 96.0796 541.808 262.154 851.095 178.161C1160.37 94.1674 1216.15 -22.0582 1342.84 1.79386",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1094 271.224C88.5916 275.614 53.3386 107.153 282.181 102.58C511.024 98.0079 537.864 267.765 852.241 179.748C1166.62 91.7394 1218.2 -27.4791 1348.22 -2.99526",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2988 273.012C86.54 275.207 46.9973 103.953 278.121 101.949C509.229 99.9374 533.955 273.386 853.422 181.345C1172.89 89.3041 1220.26 -32.899 1353.61 -7.79163",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4832 274.799C84.4832 274.799 40.651 100.752 274.025 101.309C507.414 101.866 530.025 279.006 854.582 182.933C1179.15 86.8681 1222.31 -38.3196 1359 -12.5887",
    stroke: "#DCE6FF",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/Pattern.6f60dfd9688068e5a60d14f5fa74ecbf.svg";
export { ForwardRef as ReactComponent };